export default __webpack_public_path__ + "static/media/checked.48d13246.svg";